import { ErrorHandler, Injectable, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DepatureboardComponent } from './depatureboard/depatureboard.component';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DebugPanelComponent } from './debug-panel/debug-panel.component';
import { DepatureboardPageComponent } from './depatureboard-page/depatureboard-page.component';
import { DualBoardComponent } from './dual-board/dual-board.component';

@Injectable()
class KioskErrorHandler implements ErrorHandler {
  private static readonly WINDOW_MS = 60000;
  private static readonly THRESHOLD = 3;

  private errorTimestamps: number[] = [];
  private reloadScheduled = false;

  handleError(error: unknown): void {
    console.error('Unhandled error:', error);

    if (this.reloadScheduled) {
      return;
    }

    const now = Date.now();
    this.errorTimestamps = [...this.errorTimestamps, now]
      .filter((timestamp) => now - timestamp < KioskErrorHandler.WINDOW_MS);

    if (this.errorTimestamps.length >= KioskErrorHandler.THRESHOLD) {
      this.reloadScheduled = true;
      setTimeout(() => window.location.reload(), 2000);
    }
  }
}

@NgModule({
  declarations: [
    AppComponent,
    DepatureboardComponent,
    DebugPanelComponent,
    DepatureboardPageComponent,
    DualBoardComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: KioskErrorHandler }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
